module.exports = "assets/yc-icons.woff?babe55";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@ycgame/icons/fonts/yc-icons.woff?niwq6g
// module id = 28
// module chunks = 1